import Vue from "vue";
import Router from "vue-router";

import menuModule from "vuex-store/modules/menu";
import lazyLoading from "../store/modules/menu/lazyLoading";

Vue.use(Router);

const demoRoutes = [];
if (process.env.NODE_ENV === "development") {
  const VueComponentTree = require("vue-component-tree").default;

  demoRoutes.push(
    VueComponentTree(require.context("./..", true, /.demo.vue$/), "/demo")
  );
}

export default new Router({
  mode: 'history',
  routes: [
    // ...demoRoutes,
    // ...generateRoutesFromMenu(menuModule.state.items),
    {
      path: "/buy",
    },
    {
      path: "/notlogged",
    },
    {
      name: 'Dashboard',
      path: '/dashboard',
      component: require('../components/dashboard/Dashboard').default,
      meta: {
        default: true,
        title: 'menu.dashboard',
        iconClass: 'vuestic-icon vuestic-icon-dashboard'
      }
    },
    {
      name: 'Domain',
      path: '/domains',
      component: require('../components/domains/Domains').default,
      meta: {
        title: 'menu.domains',
        iconClass: 'vuestic-icon vuestic-icon-maps'
      }
    },
    {
      name: "Order",
      path: "/addorder",
      component: require('../components/order/Card').default,
      meta: {
        title: "menu.order",
        iconClass: "vuestic-icon vuestic-icon-components",
      },
    },
    {
      name: 'Upgrade',
      path: '/upgrade',
      component: require('../components/upgrade/Upgrade').default,
      meta: {
        title: 'menu.upgrade',
        iconClass: 'vuestic-icon vuestic-icon-settings'
      }
    },
    {
      name: "Firewall",
      path: "/firewalls",
      component: require('../components/firewalls/Firewalls').default,
      meta: {
        default: false,
        title: "menu.firewalls",
        newWindow: false,
      },
    },
    {
      path: "/firewalls/:firewall",
      component: require("../components/firewalls/Firewall").default,
    },
    {
      name: "Anti DDoS Attacks",
      path: "/attacks",
      component: require("../components/attacks/Attacks").default,
      meta: {
        default: false,
        title: "menu.ddos_attacks",
        newWindow: false,
      },
    },
    {
      path: "/attacks/:attack",
      component: require("../components/attacks/Attacks").default,
    },
    {
      name: "DNS",
      path: "/dns",
      component: require("../components/dns/Domains").default,
      meta: {
        default: false,
        title: "menu.dns",
        newWindow: false,
      },
    },
    {
      path: "/dns/:dns",
      component: require("../components/dns/DomainConfig").default,
    },
    {
      name: "VPC",
      path: "/network/vpc",
      meta: {
        default: false,
        title: "menu.vpc",
        newWindow: false,
        newFrontend: true
      },
    },
    {
      name: "Floating IP",
      path: "/network/floating-ip",
      meta: {
        default: false,
        title: "menu.floatingIp",
        newWindow: false,
        newFrontend: true
      },
    },
    {
      name: 'Login',
      path: '/auth/login',
      component: require('../components/auth/login/Login').default,
      meta: {
        default: false,
        title: 'menu.clientArea',
        newWindow: false
      }
    },
    {
      path: "/custom_iso_space",
      component: require("../components/CustomIso/CustomIsoSpace").default,
    },
    {
      name: 'Invoices',
      path: '/invoices',
      component: require('../components/Invoices/Pages/Invoices').default,
      meta: {
        title: 'menu.invoices',
        iconClass: 'vuestic-icon vuestic-icon-tables'
      }
    },    
    {
      path: "/my_invoices",
      component: require("../components/Invoices/Pages/Invoices").default,
    },
    {
      name: "management",
      path: "/management/:id",
      component: require("../components/management/Management").default,
    },
    {
      name: "novnc",
      path: "/novnc/:id",
      component: require("../components/management/Novnc").default,
    },
    {
      path: "*",
      redirect: { name: getDefaultRoute(menuModule.state.items).name },
    },
  ],
});

function generateRoutesFromMenu(
  menu = [],
  routes = []
) {
  for (let i = 0, l = menu.length; i < l; i++) {
    let item = menu[i];
    if (item.path) {
      routes.push(item);
    }
    if (item.children) {
      generateRoutesFromMenu(item.children, routes);
    }
  }

  return routes;
}

function getDefaultRoute(menu = []) {
  let defaultRoute;

  menu.forEach((item) => {
    if (item.meta.default) {
      defaultRoute = item;
    } else if (item.children) {
      let defaultChild = item.children.find((i) => i.meta.default);
      defaultRoute = defaultChild || defaultRoute;
    }
  });

  return defaultRoute;
}



// WEBPACK FOOTER //
// ./src/router/index.js